var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortraitInActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 42,
    viewBox: "0 0 23 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 1H4.9375C2.76288 1 1 2.76288 1 4.9375V36.4375C1 38.6121 2.76288 40.375 4.9375 40.375H18.0625C20.2371 40.375 22 38.6121 22 36.4375V4.9375C22 2.76288 20.2371 1 18.0625 1Z",
    stroke: "#667085",
    strokeWidth: 1.47656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortraitInActiveIcon);
export default __webpack_public_path__ + "static/media/portraitInActiveIcon.3fb49d9fe6d654e5a99f3e66a4eee8c9.svg";
export { ForwardRef as ReactComponent };